import { RelativeSpinner } from '@components/core-ui/spinners/Spinner/RelativeSpinner';
import { Wrapper } from './styles/Wrapper';

export const Initialization = () => {
  return (
    <Wrapper>
      <RelativeSpinner className="relative h-[65px] w-[65px]" />
      <h1>Please wait...</h1>
    </Wrapper>
  );
};
